export default __webpack_public_path__ + "f51caeaf7bc31baefdd8e4fc48d1faf3.png";